import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=19b56762&"
import script from "./Technology.vue?vue&type=script&lang=js&"
export * from "./Technology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports